import { useEffect, useState } from 'react';
import { useTranslation } from '../../i18n/LocaleContext';

export default function CurrencyPickerSheet({
  open,
  title,
  options,
  selectedId,
  onClose,
  onConfirm,
}) {
  const { t } = useTranslation();
  const [draftId, setDraftId] = useState(selectedId);

  useEffect(() => {
    if (open) {
      setDraftId(selectedId);
    }
  }, [open, selectedId]);

  if (!open) {
    return null;
  }

  return (
    <div className="deposit-sheet" role="presentation" onClick={onClose}>
      <div
        className="deposit-sheet__panel"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="deposit-sheet__header">
          <button type="button" className="deposit-sheet__action" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <strong>{title || t('deposit.selectCurrency')}</strong>
          <button
            type="button"
            className="deposit-sheet__action deposit-sheet__action--confirm"
            onClick={() => onConfirm?.(draftId)}
          >
            {t('common.confirm')}
          </button>
        </header>
        <ul className="deposit-sheet__list">
          {options.map((item) => (
            <li key={item.channelId || item.id}>
              <button
                type="button"
                className={`deposit-sheet__option ${draftId === (item.channelId || item.id) ? 'is-active' : ''}`}
                onClick={() => setDraftId(item.channelId || item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
